<template>
  <div v-rect-loading="loading" class="button-setting-list">
    <div v-if="!hiddenTitle" class="title">{{ $t(titleI18nKey) }}</div>
    <table class="table">
      <tr class="header">
        <th class="setting-name setting-table-title">{{ $t(buttonSettingI18nKey) }}</th>
        <th class="action setting-table-title">{{ $t(`${i18nPrefix}.label.buttonOperation`) }}</th>
      </tr>
      <tbody class="body">
        <tr v-for="item in settingList" :key="item.key">
          <td>{{ item.i18nName }}</td>
          <td class="action">
            <el-switch
              v-model="item[switchKey]"
              active-color="#13ce66"
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { addI18nProperty } from '@/i18n'
import _ from 'lodash'

export default {
  components: {
  },
  props: {
    buttonSettingList: {
      type: Array,
      default: () => []
    },
    hiddenTitle: {
      type: Boolean,
      default: false
    },
    buttonSettingI18nKey: {
      type: String,
      default: ''
    },
    switchKey: {
      type: String,
      default: 'show'
    },
    titleI18nKey: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.company.customLandingPage',
      loading: false
    }
  },
  computed: {
    settingList () {
      return _.map(this.buttonSettingList, item => addI18nProperty(item, 'i18nName', 'cn_name', 'en_name'))
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.button-setting-list {
  margin-top: 20px;
  .title {
    font-size: 20px;
  }

  .table {
    margin-top: 20px;
    border-collapse: collapse;
    border-spacing: 0;
    empty-cells: show;
    width: 100%;

    .header {
      border: 1px solid #b2b5b7;

      .setting-table-title {
        color: #626365;
        border: 1px solid #b2b5b7;
        text-align: center;
        background: #ddd;
        padding: 10px;
        font-size: 12px;
        font-weight: normal;
      }
    }

    .body {
      tr {
        border: 1px solid #b2b5b7;
        vertical-align: middle;

        td {
          padding: 10px;
          text-align: left;
          font-weight: normal;
          vertical-align: middle;
          word-break: normal;
          border: 1px solid #b2b5b7;

          &.action {
            text-align: center;
          }
        }
      }
    }
  }
}
</style>
